import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import AuthenticationService from '../services/AuthenticationService';

Vue.use(VueRouter);

/**
 * the vue router is defined and the routes are declared
 */
const routes: Array<RouteConfig> = [
  {
    path: '/callback',
    name: 'Callback',
    component: () => import('../views/CallbackView/CallbackView.vue'),
  },
  {
    path: '/dashboard',
    name: 'Home',
    component: () => import('../views/Dashboard/DashboardHandler.vue'),
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/subject-detail/:id',
    name: 'SubjectDetail',
    component: () => import('../views/SubjectDetailView/SubjectDetailView.vue'),
  },
  {
    path: '/apprentice-detail/:id',
    name: 'ApprenticeDetail',
    component: () =>
      import('../views/ApprenticeDetailView/ApprenticeDetailView.vue'),
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import('../views/StatusPage/StatusPage.vue'),
    props: {
      statusCode: 403,
      statusTextKey: 'error.forbidden',
      showHomeButton: true,
    },
  },
  {
    path: '/internal-server-error',
    name: 'Internal Server Error',
    component: () => import('../views/StatusPage/StatusPage.vue'),
    props: {
      statusTextKey: 'error.internalServerError',
      showHomeButton: false,
    },
  },
  {
    path: '/*',
    name: 'PageNotFound',
    component: () => import('../views/StatusPage/StatusPage.vue'),
    props: {
      statusCode: 404,
      statusTextKey: 'error.notFound',
      showHomeButton: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

/**
 * check if user is authenticated
 */
router.beforeEach(async (to, from, next) => {
  if (to.path === '/callback') next();
  else if (!(await AuthenticationService.isTokenExpired())) next();
  else await AuthenticationService.signinRedirect();
});

export default router;
